var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrib(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3363_77817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.625 14.375V16.875",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.375 14.375V16.875",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.375 23.125C24.375 23.4565 24.2433 23.7745 24.0089 24.0089C23.7745 24.2433 23.4565 24.375 23.125 24.375H6.875C6.54348 24.375 6.22554 24.2433 5.99112 24.0089C5.7567 23.7745 5.625 23.4565 5.625 23.125V16.875H24.375V23.125Z",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 16.875V24.375",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 16.875V24.375",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 16.875V24.375",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.625 16.875V24.375",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.125 5.625V9.375",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.375 6.875V9.5425",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.875 6.875V9.5425",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 6.875H23.125",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.625C12.5 10.9565 12.6317 11.2745 12.8661 11.5089C13.1005 11.7433 13.4185 11.875 13.75 11.875C14.0815 11.875 14.3995 11.7433 14.6339 11.5089C14.8683 11.2745 15 10.9565 15 10.625C15 10.2935 14.8683 9.97554 14.6339 9.74112C14.3995 9.5067 14.0815 9.375 13.75 9.375C13.4185 9.375 13.1005 9.5067 12.8661 9.74112C12.6317 9.97554 12.5 10.2935 12.5 10.625Z",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 10.625C16.875 10.9565 17.0067 11.2745 17.2411 11.5089C17.4755 11.7433 17.7935 11.875 18.125 11.875C18.4565 11.875 18.7745 11.7433 19.0089 11.5089C19.2433 11.2745 19.375 10.9565 19.375 10.625C19.375 10.2935 19.2433 9.97554 19.0089 9.74112C18.7745 9.5067 18.4565 9.375 18.125 9.375C17.7935 9.375 17.4755 9.5067 17.2411 9.74112C17.0067 9.97554 16.875 10.2935 16.875 10.625Z",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25 10.625C21.25 10.9565 21.3817 11.2745 21.6161 11.5089C21.8505 11.7433 22.1685 11.875 22.5 11.875C22.8315 11.875 23.1495 11.7433 23.3839 11.5089C23.6183 11.2745 23.75 10.9565 23.75 10.625C23.75 10.2935 23.6183 9.97554 23.3839 9.74112C23.1495 9.5067 22.8315 9.375 22.5 9.375C22.1685 9.375 21.8505 9.5067 21.6161 9.74112C21.3817 9.97554 21.25 10.2935 21.25 10.625Z",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3363_77817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrib);
export default __webpack_public_path__ + "static/media/crib.c823ac17.svg";
export { ForwardRef as ReactComponent };